// @flow
import { Map }     from 'immutable';
import { Reducer } from '../../Reducer';
import {
    simpleOnGetFail,
    simpleOnGetRequest,
    simpleOnGetSuccess,
    simpleOnItemCreateDone,
    simpleOnItemCreateFail,
    simpleOnItemCreateRequest,
    simpleOnItemCreateSuccess,
    simpleOnItemLoadFail,
    simpleOnItemLoadRequest,
    simpleOnItemLoadSuccess,
    simpleOnItemUpdateDone,
    simpleOnItemUpdateFail,
    simpleOnItemUpdateRequest,
    simpleOnItemUpdateSuccess
}                  from '../../utils';
import * as TYPES  from './types';

const DEFAULT_STATE = Map({
    busy:  false,
    error: null,
    items: [],
    item:  null,
});

export default class ItemsReducer extends Reducer {
    NAME = 'ItemSpecifications';

    alias = {
        [ TYPES.ITEM_SPECIFICATIONS_GET_REQUEST ]:                'onGetRequest',
        [ TYPES.ITEM_SPECIFICATIONS_GET_SUCCESS ]:                'onGetSuccess',
        [ TYPES.ITEM_SPECIFICATIONS_GET_FAIL ]:                   'onGetFailure',
        [ TYPES.ITEM_SPECIFICATION_CREATE_REQUEST ]:              'onItemCreateRequest',
        [ TYPES.ITEM_SPECIFICATION_CREATE_SUCCESS ]:              'onItemCreateSuccess',
        [ TYPES.ITEM_SPECIFICATION_CREATE_FAIL ]:                 'onItemCreateFailure',
        [ TYPES.ITEM_SPECIFICATION_CREATE_DONE ]:                 'onItemCreateDone',
        [ TYPES.ITEM_SPECIFICATION_LOAD_REQUEST ]:                'onItemLoadRequest',
        [ TYPES.ITEM_SPECIFICATION_LOAD_SUCCESS ]:                'onItemLoadSuccess',
        [ TYPES.ITEM_SPECIFICATION_LOAD_FAIL ]:                   'onItemLoadFailure',
        [ TYPES.ITEM_SPECIFICATION_UPDATE_REQUEST ]:              'onItemUpdateRequest',
        [ TYPES.ITEM_SPECIFICATION_UPDATE_SUCCESS ]:              'onItemUpdateSuccess',
        [ TYPES.ITEM_SPECIFICATION_UPDATE_FAIL ]:                 'onItemUpdateFailure',
        [ TYPES.ITEM_SPECIFICATION_UPDATE_DONE ]:                 'onItemUpdateDone',
        [ TYPES.ITEM_SPECIFICATION_IS_CREATED_OR_UPDATED ]:       'onItemIsCreatedOrUpdated',
        [ TYPES.ITEM_SPECIFICATION_IS_CREATED_OR_UPDATED_RESET ]: 'onItemIsCreatedOrUpdatedReset',
    };

    /**
     *
     * @param state
     * @param payload
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onGetRequest = simpleOnGetRequest(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onGetSuccess = simpleOnGetSuccess(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onGetFailure = simpleOnGetFail(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param payload
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemLoadRequest = simpleOnItemLoadRequest(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemLoadSuccess = simpleOnItemLoadSuccess(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemLoadFailure = simpleOnItemLoadFail(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param payload
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemCreateRequest = simpleOnItemCreateRequest(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemCreateSuccess = simpleOnItemCreateSuccess(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemCreateFailure = simpleOnItemCreateFail(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemCreateDone = simpleOnItemCreateDone(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param payload
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemUpdateRequest = simpleOnItemUpdateRequest(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemUpdateSuccess = simpleOnItemUpdateSuccess(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemUpdateFailure = simpleOnItemUpdateFail(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemUpdateDone = simpleOnItemUpdateDone(DEFAULT_STATE);

    onItemIsCreatedOrUpdated ( state = DEFAULT_STATE ) {
        return {
            ...state,
            item_is_created_or_updated: true,
        };
    };

    onItemIsCreatedOrUpdatedReset ( state = DEFAULT_STATE ) {
        return {
            ...state,
            item_is_created_or_updated: false
        };
    };

}
